import React, { Component, Fragment } from 'react';
import { Button, Card, Col, Form, Input, InputNumber, Row, Switch } from 'antd';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageListComponent, HeaderListComponent } from "../../../common/component/Index";
import TranslateButton from '../../../common/component/TranslateButton';
import * as Func from '../../../../../helpers/functions';
import { FEATURE_FLAGS, PATHS } from "../../../../../constants/Define";
import { getOptionDetail, updateOption, translateOption, deleteOptionTranslate } from '../../../../../actions/fnbAction';

const FormItem = Form.Item;

const emptyOption = {
    id: null,
    fnbProductId: '',
    code: '',
    isRequired: false,
    minSelection: 0,
    maxSelection: 0,
    level: 0,
    order: 0,
    parentId: '',
    isActive: false,
    createdDate: '',
    languageCode: 'vi-VN',
    translations: [],
};

class OptionDetail extends Component {
    state = {
        option: emptyOption,
    };

    componentDidMount() {
        const { match } = this.props;
        const id = match?.params?.id;
        if (id) {
            this.props.actions.getOptionDetail(id);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.optionDetail !== this.props.optionDetail && this.props.optionDetail) {
            const option = this.normalizeOptionDetail(this.props.optionDetail);
            this.setState({ option });
        }

        if (!prevProps.optionUpdateSuccess && this.props.optionUpdateSuccess) {
            this.props.history.goBack();
        }
    }

    handleChangeName = (event) => {
        const name = event.target.value;
        this.setState((prevState) => ({
            option: {
                ...prevState.option,
                name,
            },
        }));
    };

    getDefaultLanguageCode = () => {
        const { option } = this.state;
        const defaultLang = (option.translations || []).find((item) => item.isDefault);
        return (defaultLang && defaultLang.languageCode) || option.languageCode || 'vi-VN';
    };

    normalizeOptionDetail = (optionDetail) => {
        const translations = optionDetail.translations || [];
        const defaultLang = translations.find((item) => item.isDefault);
        const languageCode = (defaultLang && defaultLang.languageCode) || optionDetail.languageCode || 'vi-VN';
        const name = this.getTranslationName(translations, languageCode) || '';
        return {
            ...optionDetail,
            translations,
            languageCode,
            name,
        };
    };

    getTranslationName = (translations, languageCode) => {
        const translation = (translations || []).find((item) => item.languageCode === languageCode);
        return translation ? translation.name : '';
    };

    handleShowTranslate = (language) => {
        if (!language || !language.code) return;
        this.setState((prevState) => ({
            option: {
                ...prevState.option,
                languageCode: language.code,
                name: this.getTranslationName(prevState.option.translations, language.code),
            },
        }));
    };

    handleExitTranslate = () => {
        this.setState((prevState) => ({
            option: {
                ...prevState.option,
                languageCode: this.getDefaultLanguageCode(),
                name: this.getTranslationName(
                    prevState.option.translations,
                    this.getDefaultLanguageCode()
                ),
            },
        }));
    };

    handleRemoveTranslate = (language) => {
        if (!language || !language.code) return;
        const translation = (this.state.option.translations || []).find(
            (item) => item.languageCode === language.code
        );
        if (translation && translation.id) {
            this.props.actions.deleteOptionTranslate({
                translateId: translation.id,
                optionId: this.state.option.id,
                languageCode: language.code,
                languageName: this.props.t(`translate.languages.${language.id}`),
            });
            return;
        }
        this.setState((prevState) => {
            const translations = (prevState.option.translations || []).filter(
                (item) => item.languageCode !== language.code
            );
            const defaultLanguageCode = this.getDefaultLanguageCode();
            const nextLanguageCode =
                prevState.option.languageCode === language.code
                    ? defaultLanguageCode
                    : prevState.option.languageCode;
            return {
                option: {
                    ...prevState.option,
                    translations,
                    languageCode: nextLanguageCode,
                    name: this.getTranslationName(translations, nextLanguageCode),
                },
            };
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { option } = this.state;
        const { match } = this.props;
        const id = match?.params?.id || option.id;
        if (!id) return;
        const defaultLanguageCode = this.getDefaultLanguageCode();
        if (option.languageCode && option.languageCode !== 'vi-VN' && option.languageCode !== defaultLanguageCode) {
            const translation = (option.translations || []).find(
                (item) => item.languageCode === option.languageCode
            );
            this.props.actions.translateOption({
                id: translation?.id,
                fnbProductOptionId: translation?.id ? undefined : id,
                optionId: id,
                name: option.name || '',
                description: '',
                languageCode: option.languageCode,
                languageName: this.props.t(`translate.languages.${option.languageCode.split('-')[0]}`),
            });
            return;
        }
        const updatePayload = this.buildUpdatePayload(option);
        this.props.actions.updateOption({ id, updatePayload });
    };

    buildUpdatePayload = (option) => ({
        id: option.id,
        fnbProductId: option.fnbProductId,
        code: option.code,
        isRequired: Boolean(option.isRequired),
        minSelection: option.minSelection,
        maxSelection: option.maxSelection,
        level: option.level,
        order: option.order,
        parentId: option.parentId,
        isActive: Boolean(option.isActive),
        createdDate: option.createdDate,
        translations: (option.translations || []).map((item) => ({
            id: item.id,
            fnbProductOptionId: item.fnbProductOptionId || option.id,
            name:
                item.languageCode === this.getDefaultLanguageCode()
                    ? (option.name || item.name || '')
                    : (item.name || ''),
            description: item.description || '',
            languageCode: item.languageCode,
            isDefault: Boolean(item.isDefault),
        })),
    });

    render() {
        const { t, match, history } = this.props;
        const { option } = this.state;

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        titleHeader={Func.capitalizeFirstLetter(
                            (`${t('action.update')} ${t('navigation.option')}`).toLowerCase()
                        )}
                        extraBreadcrumbs={[
                            { title: t('navigation.option'), path: PATHS.FNB.OPTION_MANAGER.LIST.path },
                            { title: t('action.update') + ' ' + t('navigation.option').toLowerCase() },
                        ]}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE && (
                            <TranslateButton
                                languages={option.translations}
                                current={option.languageCode}
                                onChange={this.handleShowTranslate}
                                onClear={this.handleExitTranslate}
                                onRemove={this.handleRemoveTranslate}
                            />
                        )}
                    />
                    <Card bordered={false}>
                        <Form layout="vertical" onSubmit={this.handleSubmit}>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label="Code">
                                        <Input value={option.code} disabled />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Name">
                                        <Input value={option.name} onChange={this.handleChangeName} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label="Product id">
                                        <Input value={option.fnbProductId} disabled />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Created date">
                                        <Input value={option.createdDate} disabled />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label="Min selection">
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            value={option.minSelection}
                                            disabled
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Max selection">
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            value={option.maxSelection}
                                            disabled
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label="Required">
                                        <Switch checked={option.isRequired} disabled />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Active">
                                        <Switch checked={option.isActive} disabled />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <FormItem label="Level">
                                        <InputNumber value={option.level} style={{ width: "100%" }} disabled />
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem label="Order">
                                        <InputNumber value={option.order} style={{ width: "100%" }} disabled />
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem label="Parent id">
                                        <Input value={option.parentId} disabled />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: "right" }}>
                                    <Button style={{ marginRight: 8 }} onClick={() => history.goBack()}>
                                        {t('action.back')}
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={this.props.optionUpdateLoading || this.props.optionTranslateLoading}
                                    >
                                        {t('action.update')}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    optionDetail: state.fnbReducer.optionDetail,
    optionDetailLoading: state.fnbReducer.optionDetailLoading,
    optionUpdateLoading: state.fnbReducer.optionUpdateLoading,
    optionUpdateSuccess: state.fnbReducer.optionUpdateSuccess,
    optionTranslateLoading: state.fnbReducer.optionTranslateLoading,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getOptionDetail,
            updateOption,
            translateOption,
            deleteOptionTranslate,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OptionDetail));
